import { toast } from 'react-toastify';
import { api } from '../api-client.config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Game } from '../types';

const createGame = (game: Game) => api.post('/game', game);

export const useCreateGameMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['create-game'],
    mutationFn: createGame,
    onSuccess: () => {
      toast.success('Game created successfully');

      queryClient.invalidateQueries({
        queryKey: ['games'],
      });
    },
  });
};
